import './onboardingStakeHolderDetails.css';
import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from 'react-router-dom';

import { CREATE_GUEST_USER, All_ONBOARD_STAKEHOLDER_ROLE } from '../../../common/URLs';
import ArrowBackIosNew from "@mui/icons-material/ArrowBackIosNew";
import { GENDER, GOV_ID_LIST, SALUTATION, BLOCK_LIST, REVENUE_BLOCK_DEFAULT_VALUE, REVENUE_CIRCLE } from '../../../common/constants';
import resolveIcon from "../../../images/resolved.png";
import { sendOTP, validateOTP } from '../../../common/Utils';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import { ADDRESS_ERROR, APPLICANT_ERROR, CONTACT_PERSON_FIRST_NAME_ERROR, MOBILE_NO_ERROR, PINCODE_NO_ERROR, SEARCH_ICON_ERROR, VALID_NAME_OF_APPLICANT, VALID_NAME_OF_APPLICANT_ERROR, INVALID_OTP_ERROR } from '../../../common/constants';
import { GET_ADDRESS_BY_PINCODE, authKey, GET_ALL_BLOCKLIST_AND_REVENUECIRCLE, GET_USER_BY_ROLES, GET_ALL_USERS, GET_USER } from '../../../common/URLs';
import { loaderService } from '../../../common/custom-loader/loader-service';
import DeleteIcon from '@mui/icons-material/Delete';
import { nameValidation } from "../../../common/commonValidations";
import { ConfirmationPopover } from '../../../common/commonPopovers/confirmationPopover';
import { Button } from '@mui/material';
import { UserContext } from "../../../App";
import { getLocalStorageItem } from '../../../common/localStorageUtils';
import { PROD } from "../../../common/constants";
import { Container, Card, CardContent, FormGroup, FormControlLabel, Checkbox, Stack, Box, Typography, Grid, FormControl, InputLabel, Select, MenuItem, TextField } from '@mui/material';
import BackButton from '../../../common/backButton';
import { toast } from 'react-toastify';
import { handleNumberFieldFocus } from '../../../common/commonFunction';
import apiClient from '../../../axios';

const GuestUserSignUp = (props) => {
    const navigate = useNavigate();
    const shoullog = useRef(true);
    const [userId, setUserId] = useState()
    const [mobileOTPValidated, setMobileOTPValidated] = useState(false);
    const [otpHidden, setOtpHidden] = useState(true);
    const [otpValue, setOtpValue] = useState()
    const [verifyMobileNo, setVerifyMobileNo] = useState(false);
    const [pincodeAddressDetails, setPincodeAddressDetails] = useState();
    const [showGrid, setShowGrid] = useState(true);
    const [showForm, setShowForm] = useState(false);
    const [showFormUpdate, setShowFormUpdate] = useState(false);
    const [userDetails, setUserDetails] = useState([]);
    const [firstName, setFirstName] = useState('');
    const [middleName, setMiddleName] = useState('');
    const [lastName, setLastName] = useState('');
    const [id, setId] = useState('');
    const [salutation, setSalutation] = useState('');
    const [gender, setGender] = useState('');
    const [mobileNumber, setMobileNumber] = useState('');
    const [emailId, setEmailId] = useState('');
    const [address, setAddress] = useState('');
    const [pincode, setPincode] = useState('');
    const [state, setState] = useState('');
    const [district, setDistrict] = useState('');
    const [govCardIdNo, setGovCardIdNo] = useState('');
    const [govCardIdType, setGovCardIdType] = useState('Aadhaar ID');
    const [roleID, setRoleID] = useState('');
    const [roleName, setRoleName] = useState('');
    let newUserDetails = {
        internalStakeHolderSalutation: '',
        fullName: '',
        Middlename: '',
        Lastname: '',
        mobileNo: '',
        Gender: '',
        email: '',
        address: '',
        pincode: '',
        OnBoardGovtIdType: 'Aadhaar ID',
        govtIdProofNumber: '',
        id: '',
        selectedPersonalRevenueCircle: '',
        selectedPersonalBlockList: '',
        state: '',
        district: ''
    };
    const [details, setDetails] = useState(newUserDetails);
    const [userDetail, setUserDetail] = useState(newUserDetails);
    const [onboardStakeHolderRollDetails, setonboardStakeHolderRollDetails] = useState();
    const [internalStakeHolderDetails, setInternalStakeHolderDetails] = useState();
    const [internalStakeHolderDetailsUpdate, setInternalStakeHolderDetailsUpdate] = useState();

    let [RollDetails, setRollDetails] = useState([]);
    let [userRoles, setuserRoles] = useState([]);
    let [userRolesUpdate, setuserRolesUpdate] = useState([]);
    const [errorMessage, setErrorMessage] = useState({
        fullNameError: '',
        contactPersonNameError: '',
        contactPersonMiddleNameError: '',
        contactPersonLastNameError: '',
        mobileNoError: '',
        pincodeError: '',
        searchError: '',
        emailIdError: '',
        addressError: '',
        govtIdCardNumberError: '',
        govtIdNoErr: '',
        govtIdTypeErr: '',
    });
    const [roleIdValue, setRoleIdValue] = useState();
    const [disabledval, setDisabledval] = useState(false);
    const [checkedval, setCheckedval] = useState(false);
    const [leadScrutinizers, setLeadScrutinizers] = useState([]);
    const [scrutinizers, setScrutinizers] = useState([]);
    const [scrutinizersArray, setScrutinizersArray] = useState();
    const [usersToBeDeleted, setUsersToBeDeleted] = useState([]);
    const [userApiData, setUserApiData] = useState();
    const [selected, setSelected] = useState();
    const location = useLocation();
    const [logModalOpen3, setLogModalOpen3] = useState(false);
    const handleConfirmLogModalClose = () => setLogModalOpen3(false);
    const handleLogModalOpen3 = (selected) => { setLogModalOpen3(true); setSelected(selected); }

    useEffect(() => {
        if (userDetail) {
            setId(userDetail?.id)
            setSalutation(userDetail?.salutation)
            setFirstName(userDetail?.firstname)
            setLastName(userDetail?.lastname)
            setMiddleName(userDetail?.middlename)
            setMobileNumber(userDetail?.mobileNo)
            setGender(userDetail?.gender)
            setEmailId(userDetail?.emailAddress)
            setGovCardIdType(userDetail?.govtIdProofType)
            setGovCardIdNo(userDetail?.govtIdProofNumber)
            setAddress(userDetail?.address)
            setPincode(userDetail?.pincode)
            setState(userDetail?.state)
            setDistrict(userDetail?.district)
            setRoleID(userDetail?.userRoles?.[0]?.roleId)
            setRoleName(userDetail?.userRoles?.[0]?.roleName)

        }

    }, [userDetail]);
    useEffect(() => {
        if (userId) {
            getUserDetails();
        }
    }, [userId]);

    function getUserDetails() {
        apiClient
            .post(GET_USER,
                {
                    "userID": userId

                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setUserDetail(response.data.user);
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    useEffect(() => {
        // if (shoullog.current) {
        //     shoullog.current = false;
        //     gellAllOnboardedRole();
        // }
        if (internalStakeHolderDetails) {
            if (!(internalStakeHolderDetails.user)) {
                toast.error(internalStakeHolderDetails?.message);
            }
            else {
                toast.success(internalStakeHolderDetails?.message);
                setShowGrid(true);
                setShowForm(false);
                const query = new URLSearchParams(location.search);
                // const { redirectTo } = queryString.parse(location.search);
                const redirectTo = query.get('redirectTo');
                // history.push(redirectTo == null ? "/apps" : redirectTo);
                if (redirectTo == null) {
                    navigate('/')
                } else {
                    navigate("/dashboardHome/requests/" + redirectTo)

                }
            }
        }

    }, [internalStakeHolderDetails]);

    function gellAllOnboardedRole() {

        apiClient
            .post(All_ONBOARD_STAKEHOLDER_ROLE,
                {

                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                const rolesArray = response.data.roles;
                if (response.data.message === "Success") {
                    if (rolesArray.length > 0) {
                        rolesArray.map(item => {
                            RollDetails.push(
                                {
                                    id: item?.id,
                                    rollName: item?.roleName,
                                }
                            );

                        });
                    }

                }

            })
            .catch(function (error) {
            });
    }
    useEffect(() => {
        setState(pincodeAddressDetails?.addresses[0] ? pincodeAddressDetails?.addresses[0]?.state : state)
        setDistrict(pincodeAddressDetails?.addresses[0] ? pincodeAddressDetails?.addresses[0]?.district : district)

    }, [pincodeAddressDetails]);
    const getPincodeAddressDetails = () => {
        if ((details.pincode).length != 6) {
            setErrorMessage({ ...errorMessage, pincodeError: "Please enter 6 digit pincode" });
        }
        else {
            loaderService.showLoader()
            setErrorMessage({ ...errorMessage, pincodeError: "" });
            setErrorMessage({ ...errorMessage, searchError: "" });
            apiClient
                .post(GET_ADDRESS_BY_PINCODE,
                    {
                        "pincode": details.pincode,
                    },
                    {
                        headers: {
                            AuthKey: authKey,
                        },
                    }
                )
                .then((response) => {
                    setPincodeAddressDetails(response.data);
                    loaderService.hideLoader()
                })
                .catch(function (error) {
                    console.log(error);
                    loaderService.hideLoader()

                });
        }
    }
    const getPincodeAddressDetailsUpdate = () => {
        if ((pincode).length != 6) {
            setErrorMessage({ ...errorMessage, pincodeError: "Please enter 6 digit pincode" });
        }

        else {
            loaderService.showLoader()
            setErrorMessage({ ...errorMessage, pincodeError: "" });
            setErrorMessage({ ...errorMessage, searchError: "" });
            apiClient
                .post(GET_ADDRESS_BY_PINCODE,
                    {
                        "pincode": pincode,
                    },
                    {
                        headers: {
                            AuthKey: authKey,
                        },
                    }
                )
                .then((response) => {
                    setPincodeAddressDetails(response.data);
                    loaderService.hideLoader()
                })
                .catch(function (error) {
                    console.log(error);
                    loaderService.hideLoader()

                });
        }

    }
    const isValidEmail = (email) => {
        return /\S+@\S+\.\S+/.test(email);
    }
    const onhandleChange = (e, roleID) => {
        setDetails({ ...details, [e.target.name]: e.target.value })
        setRoleIdValue(roleID);
        setDisabledval(!disabledval);
        setCheckedval(!checkedval);
        if (e.target.name === "allinternalroles") {
            const { value, checked } = e.target;
            if (checked) {
                userRoles.push(
                    {
                        roleID: value,
                        roleName: null
                    }

                );
            }

            else {
                let uncheckedRoll = userRoles.filter(function (userRoles) {
                    return userRoles.roleID == value;
                });

                uncheckedRoll.map((uncheckeitem, index) => {
                    userRoles.pop(
                        {
                            roleID: uncheckeitem.roleID,
                            roleName: null
                        }
                    );
                })
            }
        }
    }
    const onRoleChange = (e, roleId) => {
        setRoleID(roleId);
        if (e.target.name === "allinternalroles") {
            const { value, checked } = e.target;
            if (checked) {
                userRolesUpdate.push(
                    {
                        roleID: value,
                        roleName: null
                    }

                );
            }

            else {
                let uncheckedRoll = userRolesUpdate.filter(function (userRolesUpdate) {
                    return userRolesUpdate.roleId == value;
                });

                uncheckedRoll.map((uncheckeitem, index) => {
                    userRolesUpdate.pop(
                        {
                            roleID: uncheckeitem.roleId,
                            roleName: null
                        }
                    );
                })
            }
        }
    }
    function onConfirmCallBack() {
        handleConfirmLogModalClose();

    }
    const handleChange = (e) => {
        setDetails({ ...details, [e.target.name]: e.target.value })
        if (e.target.name === "email") {
            if ((e.target.value).length > 0) {
                if (isValidEmail(e.target.value)) {
                    setErrorMessage({ ...errorMessage, emailIdError: " " })
                } else setErrorMessage({ ...errorMessage, emailIdError: "Please enter valid email" })
            } else setErrorMessage({ ...errorMessage, emailIdError: "Please enter Email Address" })
        }
        if (e.target.name === "fullName") {
            setDetails({ ...details, [e.target.name]: e.target.value.replace(/[^a-z]/gi, '') })
            if ((e.target.value).length > 0) {
                const Firstname_regex = /^[a-zA-Z]+$/;
                if (!((e.target.value).match(Firstname_regex))) {
                    setErrorMessage({ ...errorMessage, contactPersonNameError: "Please provide valid Name" })
                } else setErrorMessage({ ...errorMessage, contactPersonNameError: " " })
            } else {
                setErrorMessage({ ...errorMessage, contactPersonNameError: "Please enter First Name" })

            }
        }
        if (e.target.name === "Middlename") {
            setDetails({ ...details, [e.target.name]: e.target.value.replace(/[^a-z]/gi, '') })
            const Middlename_regex = /^[a-zA-Z]+$|^$/;
            if (!((e.target.value).match(Middlename_regex))) {
                setErrorMessage({ ...errorMessage, contactPersonMiddleNameError: "Please provide valid Name" })
            }
            else {
                setErrorMessage({ ...errorMessage, contactPersonMiddleNameError: "" })
            }

        }
        if (e.target.name === "Lastname") {
            setDetails({ ...details, [e.target.name]: e.target.value.replace(/[^a-z]/gi, '') })
            const Lastname_regex = /^[a-zA-Z]+$|^$/;
            if (!((e.target.value).match(Lastname_regex))) {
                setErrorMessage({ ...errorMessage, contactPersonLastNameError: "Please provide valid Name" })
            }
            else {
                setErrorMessage({ ...errorMessage, contactPersonLastNameError: "" })
            }

        }
        if (e.target.name === "mobileNo") {
            const limit = 10;
            setDetails({ ...details, [e.target.name]: e.target.value.slice(0, limit) })
            if ((e.target.value).length < 10) {
                setErrorMessage({ ...errorMessage, mobileNoError: "Please enter 10 digit mobile number" });
            }
            else setErrorMessage({ ...errorMessage, mobileNoError: "" });

        }
    }

    const onClickVerifyMobileNo = (e) => {
        e.preventDefault();
        setErrorMessage({ ...errorMessage, OTPError: "" });
        setOtpValue("");
        if (isValidMobileNumber(details.mobileNo)) {
            sendOTP(details.mobileNo, callBackMobileValidation);
            setErrorMessage({ ...errorMessage, mobileNoError: "" });
        }
        else
            setErrorMessage({ ...errorMessage, mobileNoError: MOBILE_NO_ERROR });
    }
    const callBackMobileValidation = (response) => {
        setErrorMessage({ ...errorMessage, mobileNoError: "" });
        if (response.isSuccess) {
            setErrorMessage({ ...errorMessage, OTPSentError: "" })
            setErrorMessage({ ...errorMessage, mobileNoError: "" });
            setVerifyMobileNo(true);
            setOtpHidden(false);
            setErrorMessage({ ...errorMessage, OTPError: "" });
        }

    }
    const onOtpChange = (e) => {
        const limit = 6;
        setOtpValue(e.target.value.slice(0, limit))
        if (e.target.value.length == 6) {
            validateOTP(details.mobileNo, e.target.value, callBackOTPValidation);
        }
    }
    const callBackOTPValidation = (response) => {
        setErrorMessage({ ...errorMessage, OTPSentError: "" });
        setErrorMessage({ ...errorMessage, mobileNoError: "" });
        if (response.isSuccess === true) {
            setVerifyMobileNo(false);
            setOtpHidden(true);
            setMobileOTPValidated(true);
            setErrorMessage({ ...errorMessage, OTPError: "" });
            setErrorMessage({ ...errorMessage, mobileNoError: "" });
        }
        else {
            setErrorMessage({ ...errorMessage, mobileNoError: INVALID_OTP_ERROR });
        }
    }
    const isValidMobileNumber = (mobileNo) => {
        if (mobileNo.length == 10) {
            return true;
        }
        return false;
    }

    const context = React.useContext(UserContext);

    function addInternalStakeholder() {
        apiClient
            .post(CREATE_GUEST_USER,
                {
                    "abrplUser": {
                        "salutation": details.internalStakeHolderSalutation ? details.internalStakeHolderSalutation : 'Mr',
                        "gender": details.Gender ? details.Gender : 'Male',
                        "firstname": details.fullName,
                        "middlename": details.Middlename,
                        "lastname": details.Lastname,
                        "address": '',
                        "pincode": '',
                        "state": '',
                        "district": '',
                        "govtIdProofType": '',
                        "govtIdProofNumber": '',
                        "mobileNo": details.mobileNo,
                        "emailAddress": details.email,
                        "isActive": 1,
                        "userRoles": [
                            {
                                "roleName": "GHD-GuestUser"

                            }
                        ]
                    },
                    "loginUserRole": getLocalStorageItem('role'),
                    "loginUserID": getLocalStorageItem('uuid') ? getLocalStorageItem('uuid') : ''
                },
                {
                    headers: {
                        AuthKey: authKey,
                    }
                },
            )
            .then((response) => {
                if (!response.data.isSuccess && response.data.message.indexOf("mobile number") >= 0) {
                    setVerifyMobileNo(false);
                    setMobileOTPValidated(false);
                }
                setInternalStakeHolderDetails(response.data);
                context.addGuestUser(response.data.user);
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    useEffect(() => {
        console.log(context.guestUser, "GUEST USER")
    }, [context.guestUser])


    const onPrevious = (e) => {
        e.preventDefault();
        setShowGrid(true);
        setShowForm(false);
        setShowFormUpdate(false);
        navigate('/')
    }
    const onSubmit = () => {
        handleConfirmLogModalClose();
        if ((details.fullName) && (details.mobileNo) && (details.email)) {
            addInternalStakeholder();
        }
        else {
            const email_regex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
            if (!(details.email.match(email_regex))) {
                if (!details.email) {
                    setErrorMessage({ ...errorMessage, emailIdError: "Enter Your Email Id." });
                }
                else {
                    setErrorMessage({ ...errorMessage, emailIdError: "Please provide valid Email" });
                }
            }
            const phone_regex = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
            if (!(details.mobileNo.match(phone_regex))) {
                if (details.mobileNo.length < 10) {
                    setErrorMessage({ ...errorMessage, mobileNoError: "Please enter 10 digit valid mobile number" });
                }

            }
            if (details.mobileNo && !(otpValue)) {
                if (mobileOTPValidated === true) {
                    setErrorMessage({ ...errorMessage, mobileNoError: "" });
                }
                else setErrorMessage({ ...errorMessage, mobileNoError: "Please verify the mobile number" });
            }
            const name_regex = /^[a-zA-Z]+$/;
            if (!(details.fullName.match(name_regex))) {
                if (!details.fullName) {
                    setErrorMessage({ ...errorMessage, contactPersonNameError: "Enter Your First Name." });
                }
                else {
                    setErrorMessage({ ...errorMessage, contactPersonNameError: "Please provide valid Name" });
                }
            }

        }
    }
    const confirm = (e) => {
        e.preventDefault();
        handleLogModalOpen3();

    }
    useEffect(() => {
        getAllUserDetails();
    }, []);


    function getAllUserDetails() {
        apiClient
            .post(GET_ALL_USERS,
                {

                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setUserDetails(response.data.users);
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    return (
        <>
            <Container maxWidth="xxl">
                {!PROD && <p style={{ textAlign: "right", fontSize: "2vh" }}>REG57</p>}
                <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                    <BackButton navigate={navigate} navigateTo='/' />
                    <Typography variant="h5" gutterBottom>
                        Guest User Sign-Up
                    </Typography>
                </Stack>
                <Card>
                    <CardContent>
                        <Grid container spacing={2} style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <Grid item xs={12} lg={6}>
                                <Grid container spacing={1} direction="row" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                    <Grid item xs={12} style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                        <Typography variant="h6" style={{ marginBottom: "1em" }} gutterBottom>
                                            General User Information
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <FormControl fullWidth>
                                            <InputLabel>Salutation</InputLabel>
                                            <Select
                                                label="Salutation"
                                                name="internalStakeHolderSalutation"
                                                value={details.internalStakeHolderSalutation}
                                                onChange={(e) => handleChange(e)}>
                                                {
                                                    SALUTATION?.map((item) =>
                                                        <MenuItem value={item}>{item}</MenuItem>)
                                                }
                                            </Select>
                                            {/* <FormHelperText sx={{ color: 'red' }}>{errorMessage?.categoryError}</FormHelperText> */}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={9}>
                                        <TextField fullWidth
                                            required
                                            error={errorMessage?.contactPersonNameError}
                                            helperText={errorMessage?.contactPersonNameError}
                                            label="First Name"
                                            inputProps={{
                                                maxLength: 20
                                            }}
                                            type="text"
                                            name="fullName"
                                            value={details.fullName}
                                            onChange={(e) => handleChange(e)} />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField fullWidth
                                            // error={errorMessage?.middleNameError}
                                            // helperText={errorMessage?.middleNameError}
                                            inputProps={{
                                                maxLength: 20
                                            }}
                                            type="text"
                                            label="Middle Name"
                                            name="Middlename"
                                            value={details.Middlename}
                                            onChange={(e) => handleChange(e)} />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField fullWidth
                                            // error={errorMessage?.lastNameError}
                                            // helperText={errorMessage?.lastNameError}
                                            label="Last Name"
                                            inputProps={{
                                                maxLength: 20
                                            }}
                                            type="text"
                                            placeholder="Last Name"
                                            name="Lastname"
                                            value={details.Lastname}
                                            onChange={(e) => handleChange(e)} autoComplete="off" />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <FormControl fullWidth>
                                            <InputLabel>Gender</InputLabel>
                                            <Select
                                                label="Gender"
                                                name="Gender" value={details.Gender} onChange={(e) => handleChange(e)}>
                                                {
                                                    GENDER?.map((item) =>
                                                        <MenuItem key={item} value={item}>{item}</MenuItem>)
                                                }
                                            </Select>
                                            {/* <FormHelperText sx={{ color: 'red' }}>{errorMessage?.categoryError}</FormHelperText> */}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={verifyMobileNo ? 6 : 9}>
                                        <TextField fullWidth
                                            required
                                            error={errorMessage.mobileNoError}
                                            helperText={errorMessage.mobileNoError}
                                            type="number"
                                            onFocus={handleNumberFieldFocus}
                                            label="Mobile no."
                                            name="mobileNo"
                                            maxLength="10"
                                            onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '.' || evt.key === '-' || evt.key === '+') && evt.preventDefault()}
                                            value={details.mobileNo}
                                            onChange={(e) => handleChange(e)}
                                            disabled={mobileOTPValidated} />
                                    </Grid>
                                    {verifyMobileNo &&
                                        <Grid item xs={3}>
                                            <TextField fullWidth
                                                type="number"
                                                onFocus={handleNumberFieldFocus}
                                                onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '.' || evt.key === '-' || evt.key === '+') && evt.preventDefault()}
                                                onChange={(e) => onOtpChange(e)}
                                                label="OTP"
                                                value={otpValue} />
                                        </Grid>
                                    }
                                    <Grid item xs={12}>
                                        {verifyMobileNo === true ?
                                            <div>
                                                <a href='#' className="commonVerifyText" onClick={(e) => onClickVerifyMobileNo(e)}>Resend OTP</a></div>
                                            : mobileOTPValidated === true ? <div className="commonVerifyText" hidden={!mobileOTPValidated}><a href="#">Verified</a>
                                                <img className="commonOtpImg" src={resolveIcon} alt="" /></div> :
                                                <button className="commonVerifyText" onClick={(e) => onClickVerifyMobileNo(e)}>Verify Mobile no.</button>
                                        }
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField fullWidth
                                            error={errorMessage?.emailIdError}
                                            helperText={errorMessage?.emailIdError}
                                            required
                                            label="Email address"
                                            type="text"
                                            multiline
                                            name="email"
                                            value={details.email}
                                            onChange={(e) => handleChange(e)}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
                <Box display='flex' alignItems="center" justifyContent="center" mt={3} >
                    <Button sx={{ minWidth: 100 }} variant="contained" onClick={(e) => onPrevious(e)}>Cancel</Button>
                    <Button sx={{ minWidth: 100, ml: 2 }} variant="contained" onClick={(e) => confirm(e)}>Submit</Button>
                </Box>
            </Container>
            <ConfirmationPopover onOpen={logModalOpen3} action="Submit" onConfirm={onSubmit} onClose={handleConfirmLogModalClose} />
        </>
    )
}

export default GuestUserSignUp;
